import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router';
import { Crown, Settings } from 'lucide-react';
import { playUiTap } from '../services/ui-sound';
import { LogoPlate } from './Brand';
import { DiscordIcon } from './Icons';
import { LanguageToggle } from './LanguageToggle';
import { SoundToggle } from './SoundToggle';
import { ThemeToggle } from './ThemeToggle';
import { Sheet } from './Sheet';


export function PublicHeader({ showLogin = true }: { showLogin?: boolean }) {
  const { t } = useTranslation();
  const [preferencesOpen, setPreferencesOpen] = useState(false);
  return (
    <>
    <a className="skip-link" href="#contenu">{t('nav.skip')}</a>
    <header className="public-header">
      <Link to="/" className="public-header__brand" aria-label={t('nav.homeAria')} onClick={() => playUiTap()}>
        <LogoPlate size="sm" adaptive />
        <span translate="no">ANIDEX</span>
      </Link>
      <div className="public-header__actions">
        <Link to="/premium" className="button button--small public-header__premium" aria-label={t('nav.premium')} title={t('nav.premium')}><Crown size={16} aria-hidden="true" /><span>{t('nav.premium')}</span></Link>
        <div className="public-header__preferences">
        <a
          className="icon-button"
          href="https://discord.gg/E56FvJArpN"
          target="_blank"
          rel="noopener noreferrer"
          aria-label={t('nav.discord')}
          title="Discord"
        >
          <DiscordIcon size={20} />
        </a>
        <LanguageToggle />
        <SoundToggle compact />
        <ThemeToggle compact />
        </div>
        {showLogin && (
          <Link to="/connexion" className="button button--small" onClick={() => playUiTap()}>
            {t('auth.signIn')}
          </Link>
        )}
        <button type="button" className="icon-button public-header__settings" aria-label={t('nav.preferences')} aria-haspopup="dialog" aria-expanded={preferencesOpen} aria-controls="public-preferences" onClick={() => setPreferencesOpen(true)}>
          <Settings size={20} aria-hidden="true" />
        </button>
      </div>
    </header>
    <Sheet id="public-preferences" open={preferencesOpen} onClose={() => setPreferencesOpen(false)} title={t('nav.preferences')} showTitle>
      <div className="menu-settings">
        <div><span>{t('language.label')}</span><LanguageToggle /></div>
        <div><span>{t('theme.label')}</span><ThemeToggle compact /></div>
        <div><span>{t('sound.group')}</span><SoundToggle /></div>
        <a className="button" href="https://discord.gg/E56FvJArpN" target="_blank" rel="noopener noreferrer"><DiscordIcon size={20} />{t('nav.discord')}</a>
      </div>
    </Sheet>
    </>
  );
}
